import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'
import tokens from '../../design/tokens'
import {
  GRID_VARIANT_COLLAPSED,
  GRID_VARIANT_DEFAULT,
  GRID_VARIANT_SMALL,
  Grid
} from '../Grid'

import { IconFAChevronDown, IconFAChevronUp, IconQuestion } from '../SVGIcons'
import { Link } from '../link'
import { DataListExtraColumn } from './DataListExtraColumn'

const Head = styled.div`
  font-weight: ${tokens.fontWeight.bold};
  color: var(--mine-shaft);
  display: flex;
`
const Th = styled.div`
  display: flex;
  grid-column: span ${props => props.span};
  padding-bottom: 10px;
  font-size: 15px;
  cursor: default;
  ${({ align }) => (align ? `justify-content: ${align};` : '')} 
  text-align: ${props => (props.align ? props.align : 'left')};
  :first-of-type {
    padding-left: 0;
  }
  :last-of-type {
    padding-right: 0;
  }
  svg {
    font-size: 15px;
    margin-left: ${tokens.grid.gutterN / 2}px;
    margin-right: 0;
  }
  a {
    cursor: ${props => (props.sortable ? 'pointer' : 'default')};
  }
`
const StyledArrowOff = styled(IconFAChevronDown)`
  color: var(--silver-chalice);
  svg {
    font-size: 12px !important;
  }
`

const StyledArrowIconFAChevronDown = styled(IconFAChevronDown)`
  svg {
    font-size: 12px !important;
  }
`

const StyledArrowIconFAChevronUp = styled(IconFAChevronUp)`
  svg {
    font-size: 12px !important;
  }
`

const StyledIconQuestion = styled.span`
  color: var(--boulder);
`
export const DataListHeader = ({
  className,
  heads,
  beforeWidth,
  afterWidth,
  orderByStatus,
  orderDescendingStatus,
  handleChangeColumnsOrderCallback,
  'data-mu-test': dataAttributeTest,
  cols,
  gridVariant
}) => {
  return (
    <>
      <Head className={className} data-mu-test={dataAttributeTest}>
        {beforeWidth && <DataListExtraColumn before width={beforeWidth} />}
        <Grid cols={cols} variant={gridVariant}>
          {heads.map((head, index) => {
            const { field, span, label, sortable, align, tooltipText } = head
            return (
              <Th key={index} span={span} sortable={sortable} align={align}>
                {sortable ? (
                  <>
                    <Link
                      onClick={() => handleChangeColumnsOrderCallback(field)}
                    >
                      {label}
                    </Link>
                    {tooltipText && (
                      <StyledIconQuestion>
                        <IconQuestion data-tip={tooltipText} />
                      </StyledIconQuestion>
                    )}

                    <Link
                      variant={
                        orderByStatus === field ? 'highlight' : 'default'
                      }
                      onClick={() => handleChangeColumnsOrderCallback(field)}
                    >
                      {orderByStatus === field ? (
                        orderDescendingStatus ? (
                          <StyledArrowIconFAChevronDown />
                        ) : (
                          <StyledArrowIconFAChevronUp />
                        )
                      ) : (
                        <StyledArrowOff />
                      )}
                    </Link>
                  </>
                ) : (
                  <div>
                    {label}
                    {tooltipText && (
                      <StyledIconQuestion>
                        <IconQuestion data-tip={tooltipText} />
                      </StyledIconQuestion>
                    )}
                  </div>
                )}
              </Th>
            )
          })}
        </Grid>
        {afterWidth && <DataListExtraColumn after width={afterWidth} />}
      </Head>
    </>
  )
}

DataListHeader.defaultProps = {
  cols: 12,
  gridVariant: GRID_VARIANT_DEFAULT
}

DataListHeader.propTypes = {
  /* Array of Column Titles (field, label, span, sortable) */
  className: PropTypes.string,
  heads: PropTypes.array,
  beforeWidth: PropTypes.string,
  afterWidth: PropTypes.string,
  orderByStatus: PropTypes.string,
  orderDescendingStatus: PropTypes.bool,
  handleChangeColumnsOrderCallback: PropTypes.func,
  'data-mu-test': PropTypes.string,
  cols: PropTypes.number,
  gridVariant: PropTypes.oneOf([
    GRID_VARIANT_DEFAULT,
    GRID_VARIANT_SMALL,
    GRID_VARIANT_COLLAPSED
  ])
}
